import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Modal extends Component {
  close = (e) => {
    e.stopPropagation();
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.onClose) {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.onClose();
    }
  };

  render() {
    return (
      <div className="modal-wrapper" role="presentation">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,react/button-has-type */}
        <button className="modal__overlay" onClick={this.close} />
        {/* eslint-disable-next-line react/destructuring-assignment */}
        <div className="modal__content" style={this.props.style}>
          {/* eslint-disable-next-line react/destructuring-assignment */}
          { this.props.header
          // eslint-disable-next-line react/destructuring-assignment
            && this.props.header}
          {/* eslint-disable-next-line react/destructuring-assignment */}
          { this.props.children }
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.element,
  header: PropTypes.element,
  onClose: PropTypes.func.isRequired,
  style: PropTypes.objectOf(PropTypes.string),
};

export default Modal;
